'use client';

import type * as Css from 'csstype';
import {useMemo} from 'react';
import {getColors} from '../utils/styles';

import * as styles from './GenericSpinner.module.scss';

const colors = getColors();

interface GenericSpinnerProps {
  size?: Css.StandardLonghandProperties<string | number>['width']; // width/height of spinner,
  color?: Css.Properties['borderLeftColor'] | string; // you can use color names as well as color values
  thickness?: Css.Properties['borderWidth']; // thickness of the spinner
  spinnerStyle?: Css.Properties['borderStyle']; // style of the spinner
  spinnerBgColor?: Css.Properties['borderColor']; // color of the non-spinning part of the spinner
  padding?: Css.Properties['padding']; // inset border, this will not affect width
}

export const GenericSpinner = ({
  size = '1.25rem',
  color = 'emerald',
  thickness = '0.25rem',
  spinnerStyle = 'solid',
  spinnerBgColor = 'silver',
  padding = 0,
}: GenericSpinnerProps) => {
  const mappedColorOrValue = colors[color] || color;
  const mapppedBgColorOrValue = colors[spinnerBgColor] || spinnerBgColor;

  const containerStyle: Css.Properties<string | number> = useMemo(
    () => ({
      width: size,
      height: size,
      padding,
    }),
    [size, padding]
  );

  const spinnerStyles: Css.Properties<string | number> = useMemo(
    () => ({
      borderWidth: thickness,
      borderStyle: spinnerStyle,
      borderColor: mapppedBgColorOrValue,
      borderLeftColor: mappedColorOrValue,
    }),
    [thickness, spinnerStyle, mappedColorOrValue, mapppedBgColorOrValue]
  );

  return (
    <div className={styles.container} style={containerStyle}>
      <span className={styles.spinner} style={spinnerStyles} />
    </div>
  );
};
